// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const groudon: PokeData = {
  "id": 383,
  "name": "groudon",
  "height": 35,
  "weight": 9500,
  "base_experience": 302,
  "types": [
    PokeType.GROUND
  ],
  "api_moves": [
    "solar-beam",
    "earthquake",
    "fissure",
    "fire-blast",
    "rest",
    "slash",
    "scary-face",
    "ancient-power",
    "eruption",
    "bulk-up",
    "mud-shot",
    "hammer-arm",
    "earth-power",
    "lava-plume",
    "precipice-blades"
  ],
  "moves": [
    "solar-beam",
    "earthquake",
    "fissure",
    "scary-face",
    "ancient-power",
    "eruption",
    "bulk-up",
    "mud-shot",
    "earth-power",
    "mud-bomb",
    "bone-throw",
    "rototiller",
    "bonemerang"
  ],
  "evolution_chain": {
    "id": 199,
    "item": null,
    "species": [
      {
        "name": "groudon",
        "order": 413,
        "types": [
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 124,
    "speed": 104,
    "ability_power": 173
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
